import { IEntity } from "@odata/BindingContext";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import DialogFormView, { IDialogFormViewProps } from "../../../views/formView/DialogFormView";
import { IFormStorageSaveResult, ISaveArgs } from "../../../views/formView/FormStorage";

class OtherPaymentsFormView extends DialogFormView<IEntity> {

    constructor(props: IDialogFormViewProps<IEntity>) {
        super(props);
        this.save = this.save.bind(this);
    }

    async save(saveArgs?: Partial<ISaveArgs>): Promise<IFormStorageSaveResult> {
        return super.save({
            ...saveArgs,
            successSubtitle: null, // no success message, will be direcly closed
            skipLoad: true
        });
    }
}

export default withPermissionContext(OtherPaymentsFormView);